import {
  useRunTemplateTransport,
  useTemplatesAllTransport,
  useTemplatesListTransport,
  type TemplatesAllData,
  type TemplatesListData,
} from "@/templates/transport"

import type { RunTemplateRecord } from "@/types/api/RunTemplateRecord"

interface UseTemplateByIdOptions<T> {
  enabled?: boolean
  refetchOnMount?: boolean | "always"
  select?: (data: RunTemplateRecord) => T
}

export function useTemplateById<T = RunTemplateRecord>(
  templateId: string,
  options?: UseTemplateByIdOptions<T>,
) {
  return useRunTemplateTransport(templateId, options)
}

interface UseTemplatesListOptions<T> {
  enabled?: boolean
  select?: (data: TemplatesListData) => T
  tagFilters?: string[]
}

export function useTemplatesList<T = TemplatesListData>(
  options?: UseTemplatesListOptions<T>,
) {
  return useTemplatesListTransport(options)
}

interface UseTemplatesAllOptions<T> {
  enabled?: boolean
  select?: (data: TemplatesAllData) => T
  tagFilters?: string[]
}

export function useTemplatesAll<T = TemplatesAllData>(
  options?: UseTemplatesAllOptions<T>,
) {
  return useTemplatesAllTransport(options)
}
